<template>
  <div>
    <v-cal-tbl-map
      :reload="reload"
      :eventClick="eventClick"
      :eventTemplate="eventTemplate"
      :noDelete="true"
      ref="calTblMap"
      :linkClick="linkClick"
      :link="link"
      :dateField="dateField"
      :getDataObject="getDataObject"
      :defaultEventColor="defaultEventColor"
      :onDataReceived="onDataReceived"
      :showMore="true"
      tableName="reminders"
    >
    </v-cal-tbl-map>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
import TakePhoto from "../components/TakePhoto.vue";

export default {
  name: "OnsiteEstimates",
  components: {
    VCalTblMap: () => import("../components/CalTblMap.vue")
  },
  props: {},
  data() {
    return {
      dateField: "date",

      defaultEventColor: "#137C15FF",
      // data_object: null,

      link: {
        field: "shipment_id",
        name: "shipment"
      },

      d: null
    };
  },
  mounted() {
    this.getDataObject();
  },
  beforeDestroy() {},
  methods: {
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },

    eventTemplate: function(e, data, obj) {
      var endTime = new Date(e.reminder_date).addHours(1);
      var ev = {
        name:
          e.description +
          " " +
          e.shipment_id +
          " " +
          e.contact.first_name +
          " " +
          e.contact.last_name,

        start: new Date(e.reminder_date),
        end: endTime,
        shipment_id: e.shipment_id,
        first_name: e.contact.first_name,
        last_name: e.contact.last_name,
        description: e.description,
        timed: true
      };

      return ev;
    },
    reload() {
      //
    },
    getDataObject() {
      var data_object = {
        object_name: "v_reminder",
        date_fields: ["date"],
        mobileBreakpoint: 0,
        table_title: "Reminders",
        tableName: "Reminders",
        hasSearch: true,
        qry: {
          $or: [
            {
              user: this.$root.user_email
            },
            { "addressed_to.email": this.$root.user_email }
          ]
        }
      };
      return data_object;
    },

    eventClick(e) {
      this.linkClick(e.event);
    },
    onDataReceived(data, d, showTable) {
      return data;
    }
  }
};
</script>

<style lang="css" scoped></style>
